<template>
  <div class="certificate-query">
    <div class="head-wrapper">
      <div class="head">{{ title }}</div>
    </div>
    <div v-show="msgShow" class="msg-right" @click="goBack">{{ msgRight }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '学习兴趣'
    },
    msgRight: {
      type: String,
      default: '返回'
    },
    msgShow: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack () {
      this.$emit('goBack')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '~@/styles/base.scss';
.head-wrapper {
  position: absolute;
  box-sizing: content-box;
  left: 30px;
  top: -25px;
  width: 82px;
  height: 30px;
  border-radius: 15px;
  border: 10px solid #fff;
  text-align: center;
  background-color: #fff;
  .head {
    width: 82px;
    height: 30px;
    border-radius: 15px;
    box-shadow: 0 2px 3px rgba(169, 123, 235, .4);
    line-height: 30px;
    text-align: center;
    color: #fff;
    background-color: $layoutBlue;
  }
}
.msg-right {
  position: absolute;
  right: 20px;
  top: -5px;
  cursor: pointer;
  padding: 0 10px;
  font-size: 14px;
  line-height: 1em;
  color: #999;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/center-item-head/center-item-head.vue